import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Grid, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useClasses = makeStyles((theme) => {
  return {
    item: {
      flex: 1,
    },
    chip: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '12px 6px',
      borderRadius: 4,
      border: '1px solid #007DAA80',
      background: '#FFFFFF',
      cursor: 'pointer',
      '&:hover': {
        borderColor: theme.palette.primary.main,
      },
    },
    selected: {
      borderColor: theme.palette.primary.main,
      background: 'rgba(0, 125, 170, 0.08)',
    },
    icon: {
      height: theme.spacing(3),
      marginBottom: theme.spacing(1),
    },
    chipText: {
      wordWrap: 'break-word',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
    },
  }
})

export type Option = {
  title: string
  subtitle?: string
  faIconSelected: IconDefinition
  faIconUnselected: IconDefinition
  value: any
}

type SelectableIconChipsProps = {
  options: Option[]
  gridItemProps?: object
  onSelect: (value: any) => void
  selectedItem?: string
}

const SelectableIconChips = ({ options, gridItemProps, onSelect, selectedItem }: SelectableIconChipsProps) => {
  const classes = useClasses()
  return (
    <Grid
      container
      spacing={2}
    >
      {options.map((option, idx) => {
        const { title, subtitle, faIconSelected, faIconUnselected, value } = option
        return (
          <Grid
            item
            {...gridItemProps}
            key={idx}
            className={classes.item}
          >
            <Box
              role="button"
              aria-label={
                selectedItem === value
                  ? `Selected: ${title} ${subtitle || ''}`
                  : `Not selected: ${title} ${subtitle || ''}`
              }
              aria-live="polite"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onSelect(value)}
              onClick={() => onSelect(value)}
              className={`${classes.chip} ${selectedItem === value ? classes.selected : ''}`}
            >
              <FontAwesomeIcon
                icon={selectedItem === value ? faIconSelected : faIconUnselected}
                className={classes.icon}
              />
              <Box className={classes.chipText}>
                <Typography
                  variant="button"
                  color="textPrimary"
                >
                  {title}
                </Typography>
                {subtitle && (
                  <Typography
                    variant="caption"
                    color="textPrimary"
                  >
                    {subtitle}
                  </Typography>
                )}
              </Box>
            </Box>
          </Grid>
        )
      })}
    </Grid>
  )
}

export default SelectableIconChips
